<!-- 车场通道信息变更上报 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                    "chargeGroupCode":"",
                    "vipGroupType":0,
                    "vipNearExpiredDayThreshold":10,
                    "customVipName":"ahaoaaa2",
                    "dynamicFullLimit":0,
                    "customVipSeq":"434",
                    "isChargeGroupRelated":0,
                    "priTimeArr":[

                    ],
                    "priChannelArr":[
                        {
                            "priType":"",
                            "channelSeq":"2"
                        }
                    ],
                    "priDateArr":[
                        {
                            "customVipSeq":"434"
                        }
                    ],
                    "parkCode":"2KKN885S",
                    "settlementAmount":0,
                    "isTimePrivilege":0,
                    "isDatePrivilege":1,
                    "isDynamicMode":0,
                    "dynamicCarportNumber":1,
                    "vipFullLimitValue":14
                },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报月票类型信息变更上报到第三方接入系统",
                urlPattern:this.commonUrls.third+"syncParkVipType",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS传统停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'customCode', info2: '是', info3: 'String', info4: 'VIP类型唯一编号，editCusVipType接口code' },
                        { info1: 'customVipSeq', info2: '是', info3: 'String', info4: 'VIP类型唯一编号' },
                        { info1: 'customVipName', info2: '是', info3: 'String', info4: 'VIP类型名称' },
                        { info1: 'settlementAmount', info2: '是', info3: 'BigDecimal', info4: '结算单价,时间结算，2位小数，表示元/月；余额结算，2位小数，表示充值比例如1.2；次数结算，表示元/次' },
                        { info1: 'isDynamicMode', info2: '是', info3: 'Integer', info4: '是否多位多车（0否，1是）' },
                        { info1: 'dynamicCarportNumber', info2: '是', info3: 'Integer', info4: '可用车位数，正整数，默认1，表示这种VIP类型可用车位数，开通VIP票时，对应VIP票可用车位数=VIP类型可用车位数 * 开通张数' },
                        { info1: 'isDatePrivilege', info2: '是', info3: 'Integer', info4: '是否区分日期（0不区分，1区分）' },
                        { info1: 'isTimePrivilege', info2: '是', info3: 'Integer', info4: '是否区分时间（0不区分，1区分）' },
                        { info1: 'isChargeGroupRelated', info2: '是', info3: 'Integer', info4: '是否自定义计费（0否，1是）' }, 
                        { info1: 'chargeGroupCode', info2: '是', info3: 'String', info4: '收费组编号(格式：停车场seq,收费组seq 例如:1,3)' },
                        { info1: 'vipGroupType', info2: '是', info3: 'Integer', info4: 'vip组类型（0普通vip，1访客vip，2黑名单vip，3预定vip，4共享vip）' },
                        { info1: 'settleType', info2: '否', info3: 'Integer', info4: '结算类型:0时间结算，1余额结算，2次数结算' },
                        { info1: 'openVipFullLimit', info2: '是', info3: 'Integer', info4: '是否开启满位控制（0否，1是）' },
                        { info1: 'vipFullLimitValue', info2: '是', info3: 'Integer', info4: '最多允许车辆数' },
                        { info1: 'vipNearExpiredDayThreshold', info2: '是', info3: 'Integer', info4: 'VIP临过期提示天数阈值' },
                        { info1: 'operateMode', info2: '是', info3: 'String', info4: '数据状态 0新增，1更新，2删除，3同步' },
                        { info1: 'priDateArr', info2: '否', info3: 'JSONArray', info4: '有效日期' },
                        { info1: 'priTimeArr', info2: '否', info3: 'JSONArray', info4: '有效时间段' },
                        { info1: 'priChannelArr', info2: '否', info3: 'JSONArray', info4: '通行权限数组' },
                        ]
                },{
                    titleName: 'priDateArr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'privilegeDate', info2: '是', info3: 'String', info4: '有效时间' },
                        ]

                },{
                    titleName: 'priTimeArr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'startTime', info2: '是', info3: 'String', info4: '起始时间' },
                        { info1: 'endTime', info2: '是', info3: 'String', info4: '结束时间' },
                        ]

                },{
                    titleName: 'priChannelArr',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'checked', info2: '是', info3: 'Boolean', info4: '是否被选中，为true代表有权限' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '结点名称' },
                        { info1: 'nodeId', info2: '是', info3: 'String', info4: '结点id' },
                        { info1: 'type', info2: '是', info3: 'Integer', info4: '结点类型 0:停车场 1: 区域,2:通道' },
                        { info1: 'parkingLotSeq', info2: '否', info3: 'Integer', info4: '停车场seq' },
                        { info1: 'priType', info2: '是', info3: 'Integer', info4: '权限类别 0无此通道权限并播报，1有此通道权限，2无此通道权限但不播报，默认值-1（-1表示无意义）' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编码' },
                        { info1: 'priChannelArr', info2: '否', info3: 'JSONArray', info4: 'type=1：区域权限，type=2： 通道权限' }
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: []
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/syncParkVipType.vue